import React, { useState } from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import ConnectionModal from '../../Components/Modals/ConnectionsModal';
import ConnectionsList from '../../Components/Lists/ConnectionsList';
import { GET_COMPANY_CONNECTIONS } from '../../graphql/queries';
import { DELETE_COMPANY_CONNECTION } from '../../graphql/mutations';
import { useQuery, useMutation } from '@apollo/client';
import ConnectionCardSkeleton from '../../Components/Skeletons/ConnectionCardSkeleton';
import PlaceholderPage from './PlaceholderPage';
import { toast } from 'react-toastify';

const MyConnections: React.FC = () => {
  const emptyImage1 = require("../../assets/images/Empty1.png");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const { data, loading, error, refetch } = useQuery(GET_COMPANY_CONNECTIONS);
  const [deleteConnection] = useMutation(DELETE_COMPANY_CONNECTION);

  const handleAddConnection = async () => {
    setIsModalOpen(false);
    await refetch();
  };

  const handleDeleteConnection = async (shopDomain: string) => {
    try {
      const response = await deleteConnection({
        variables: { shopDomain },
      });

      if (response.data.deleteCompanyConnection) {
        // Refetch connections after deletion
        await refetch();
      } else {
        toast.error(response.data.deleteCompanyConnection.message || "Failed to delete connection.");
      }
    } catch (err) {
      console.error("Delete error:", err);
      toast.error("An error occurred while deleting the connection.");
    }
  };

  return (
    <Container>
      <Box
        my={4}
        sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Typography variant="h4" gutterBottom>
          My Connections
        </Typography>
        <Button variant="contained" color="primary" onClick={() => setIsModalOpen(true)}>
          Add Connection
        </Button>
      </Box>

      {loading && <ConnectionCardSkeleton />}

      {error && (
        <Typography color="error" data-testid="error-message">
          Error: Failed to load company connections.
        </Typography>
      )}

      {/* Display Connections List */}
      {!loading && !error && data?.companyConnections?.length > 0 && (
        <ConnectionsList
          connections={data.companyConnections}
          onDelete={handleDeleteConnection}
        />
      )}

      {/* Empty Placeholder */}
      {!loading && data?.companyConnections?.length === 0 && (
        <PlaceholderPage
          title=""
          emptyStateText="You have no connections yet."
          emptyStateImage={emptyImage1}
          actionButtons={<></>}
        />
      )}

      <ConnectionModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAddConnection={handleAddConnection}
      />
    </Container>
  );
};

export default MyConnections;
